(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_lktn-bundle-info-tooltip"] && !Shopify.designMode) return;
  try {
    (function() {
  function positionTooltip(badge, tooltip) {
    tooltip.style.left = '50%';
    tooltip.style.transform = 'translateX(-50%)';

    var rect = tooltip.getBoundingClientRect();
    var margin = 8;

    if (rect.left < margin) {
      var shift = margin - rect.left;
      tooltip.style.left = 'calc(50% + ' + shift + 'px)';
    } else if (rect.right > window.innerWidth - margin) {
      var shift = rect.right - (window.innerWidth - margin);
      tooltip.style.left = 'calc(50% - ' + shift + 'px)';
    }
  }

  function initTooltips() {
    document.querySelectorAll('.badge--bundle').forEach(function(badge) {
      if (badge.dataset.tooltipInit) return;
      badge.dataset.tooltipInit = 'true';

      var parts = badge.dataset.lktntooltip.split('|');
      var tooltip = document.createElement('div');
      tooltip.className = 'lktn-tooltip';
      tooltip.innerHTML = '<div class="lktn-tooltip-price">' + parts[0] + '</div><div class="lktn-tooltip-note">' + parts[1] + '</div>';
      badge.appendChild(tooltip);

      badge.addEventListener('click', function(e) {
        e.stopPropagation();
        var isVisible = tooltip.classList.contains('lktn-visible');
        document.querySelectorAll('.lktn-tooltip.lktn-visible').forEach(function(t) {
          t.classList.remove('lktn-visible');
        });
        if (!isVisible) {
          tooltip.classList.add('lktn-visible');
          positionTooltip(badge, tooltip);
        }
      });
    });

    document.addEventListener('click', function() {
      document.querySelectorAll('.lktn-tooltip.lktn-visible').forEach(function(t) {
        t.classList.remove('lktn-visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltips);
  } else {
    initTooltips();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_lktn-mix-match"] && !Shopify.designMode) return;
  try {
    function mmSetup() {

    const packages = document.querySelectorAll('.mm-package-item');
    const quantityInput = document.querySelector('.quantity-selector__input');

    packages.forEach((p) => {

      if (p.classList.contains('mm-setup')){
        console.log('mm-setup event is already added');
      } else {
        p.classList.add('mm-setup');
        p.addEventListener('click', function () {
          const qty = p.getAttribute('data-qty');        
          quantityInput.value = qty;
          quantityInput.dispatchEvent(new Event('change'))
          
        });
      }
    });

    quantityInput.addEventListener('change', function(){      
      packages.forEach(p => {
        p.classList.remove('mm-selected');
      });

      var newPackage = document.querySelector('.mm-package-item[data-qty="' + quantityInput.value + '"]');
      if (newPackage != null) {
        newPackage.classList.add('mm-selected');
      }
    });    

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            quantityInput.dispatchEvent(new Event('change'));
        })
    });

  }

  document.addEventListener('variant:change', () => mmSetup());
  document.addEventListener('DOMContentLoaded', () => mmSetup());
  } catch(e) { console.error(e); }
})();

})();
